var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandFigmaStyleBrand = function SvgBrandFigmaStyleBrand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M8.401 22.8c1.988 0 3.6-1.613 3.6-3.6v-3.6h-3.6a3.6 3.6 0 0 0-3.6 3.6c0 1.987 1.613 3.6 3.6 3.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M4.801 12c0-1.987 1.613-3.6 3.6-3.6h3.6v7.2h-3.6a3.6 3.6 0 0 1-3.6-3.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M4.802 4.8c0-1.987 1.613-3.6 3.6-3.6h3.6v7.2h-3.6a3.6 3.6 0 0 1-3.6-3.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M12.002 1.2h3.6c1.987 0 3.6 1.613 3.6 3.6s-1.613 3.6-3.6 3.6h-3.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M19.202 12c0 1.987-1.613 3.6-3.6 3.6a3.6 3.6 0 0 1-3.6-3.6c0-1.987 1.613-3.6 3.6-3.6s3.6 1.613 3.6 3.6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandFigmaStyleBrand);
export { ForwardRef as ReactComponent };